import React from 'react';



export function HorizontalSlider({ id, outputId, outputVal, label, _class, min, max, onChange, defaultValue }) {
  return (
    <div>
      <label className="slider-label" htmlFor={id}>{label}</label>
      <input type="range" id={id} min={min} max={max} className={_class} onChange={(e) => onChange(e.target.value)} defaultValue={defaultValue} />
    </div>
  )
}

export function VerticalSlider({ id, label, min, max, _class, onChange, defaultValue }) {
  return (
    <div>
      <label className="slider-label" htmlFor={id}>{label}</label>
      <input type="range" className={`${_class} vertical`} orient="vertical" id={id} min={min} max={max}
        defaultValue={defaultValue} onChange={(e) => onChange(e.target.value)} />
    </div>
  )
}

export function DatePicker({ id, label, min, max, _class }) {
  return (
    <div>
      <label htmlFor={id}>{label}</label>
      <input type="date" className={_class} id={id} />
    </div>
  )
}

export function RadioButton({ id, name, label, value, _class, disabled, onClick, checked }) {
  if (checked) {
    return (
      <div className={`radio-button ${_class}`}>
        <input id={id} name={name} type="radio" disabled={disabled} onClick={onClick} value={value} defaultChecked />
        <label htmlFor={id}>{label}</label>
      </div>
    )
  }
  return (
    <div className={`radio-button ${_class}`}>
      <input  id={id} name={name} type="radio" disabled={disabled} onClick={onClick} value={value} />
      <label htmlFor={id}>{label}</label>
    </div>
  )
}

























/* END */



// WEBPACK FOOTER //
// ./src/weather/components/inputs.js